var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    transform: "translate(-3803 -12490)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chevron-circle-down",
    className: "st0",
    d: "M3813,12510c-5.5,0-10-4.5-10-10s4.5-10,10-10s10,4.5,10,10S3818.5,12510,3813,12510 z M3813,12508c4.4,0,8-3.6,8-8s-3.6-8-8-8s-8,3.6-8,8S3808.6,12508,3813,12508z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check",
    className: "st0",
    d: "M3811.9,12504.4c-0.2,0-0.5-0.1-0.7-0.3l-3.9-3.9c-0.4-0.4-0.4-1,0-1.3c0.4-0.4,0.9-0.4,1.3,0l0,0 l3.3,3.3l5.9-5.9c0.4-0.4,0.9-0.4,1.3,0c0.4,0.4,0.4,1,0,1.3l0,0l-6.6,6.6C3812.3,12504.3,3812.1,12504.4,3811.9,12504.4z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check.1a3371ad52d4157e405899b18cecbe2c.svg";